import { render } from "./PromptViewModal.vue?vue&type=template&id=8f2ed022"
import script from "./PromptViewModal.vue?vue&type=script&lang=js"
export * from "./PromptViewModal.vue?vue&type=script&lang=js"

import "./PromptViewModal.vue?vue&type=style&index=0&id=8f2ed022&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__